module.exports = "export default __webpack_public_path__ + &quot;fab3348b6b5ae040fcf5e10805ce618a.svg&quot;;"